import { render } from "./TranslationButton.vue?vue&type=template&id=469ff545&scoped=true"
import script from "./TranslationButton.vue?vue&type=script&lang=js"
export * from "./TranslationButton.vue?vue&type=script&lang=js"

import "./TranslationButton.vue?vue&type=style&index=0&id=469ff545&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469ff545"]])

export default __exports__